import clsx from 'clsx';
import type { ComponentPropsWithoutRef } from 'react';

export function ListWrapper({
    children,
    className,
    ...restProps
}: ComponentPropsWithoutRef<'div'>) {
    return (
        <div role="list" className={clsx('flex flex-col space-y-2', className)} {...restProps}>
            {children}
        </div>
    );
}
